import {Container, inject, injectable} from 'inversify';
import getDecorators from 'inversify-inject-decorators';

const inversifyContainer = new Container();
const decorators = getDecorators(inversifyContainer, false);
const {lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject} = decorators;

export {inversifyContainer, lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject, inject, injectable};
